export type MockupView = "front" | "back" | "side" | "sleeve";

export type PrintableArea = {
  x: number;
  y: number;
  width: number;
  height: number;
  unit?: "px" | "percent";
};

export type MockupGarmentView = {
  view: MockupView;
  label: string;
  image: string;
  printableArea: PrintableArea;
  previewOnly?: boolean;
  centerOffsetX?: number;
  centerOffsetY?: number;
  defaultOffsetX?: number;
  defaultOffsetY?: number;
};

export type MockupGarment = {
  id: string;
  label: string;
  views: MockupGarmentView[];
};

export const mockupGarments: MockupGarment[] = [
  {
    id: "adult-tee",
    label: "Adult T-Shirt",
    views: [
      {
        view: "front",
        label: "Front",
        image: "/mockups/adult-tee-front.png",
        printableArea: {
          x: 0.39,
          y: 0.24,
          width: 0.22,
          height: 0.28,
          unit: "percent",
        },
        centerOffsetX: 0,
        centerOffsetY: 0,
        defaultOffsetX: 0,
        defaultOffsetY: -8,
      },
      {
        view: "back",
        label: "Back",
        image: "/mockups/adult-tee-back.png",
        printableArea: {
          x: 0.39,
          y: 0.20,
          width: 0.22,
          height: 0.28,
          unit: "percent",
        },
        centerOffsetX: 0,
        centerOffsetY: 0,
        defaultOffsetX: 0,
        defaultOffsetY: -6,
      },
      {
        view: "side",
        label: "Side",
        image: "/mockups/adult-tee-side.png",
        printableArea: {
          x: 0.38,
          y: 0.24,
          width: 0.18,
          height: 0.28,
          unit: "percent",
        },
        previewOnly: true,
        centerOffsetX: 0,
        centerOffsetY: 0,
        defaultOffsetX: 0,
        defaultOffsetY: -6,
      },
    ],
  },
  {
    id: "hoodie",
    label: "Hoodie",
    views: [
      {
        view: "front",
        label: "Front",
        image: "/mockups/hoodie-front.png",
        printableArea: {
          x: 0.27,
          y: 0.22,
          width: 0.46,
          height: 0.40,
          unit: "percent",
        },
        centerOffsetX: 0.5,
        centerOffsetY: 5,
        defaultOffsetX: 0,
        defaultOffsetY: -6,
      },
      {
        view: "back",
        label: "Back",
        image: "/mockups/hoodie-back.png",
        printableArea: {
          x: 0.28,
          y: 0.26,
          width: 0.44,
          height: 0.36,
          unit: "percent",
        },
        centerOffsetX: 2.5,
        centerOffsetY: 8,
        defaultOffsetX: 0,
        defaultOffsetY: -4,
      },
    ],
  },
  {
    id: "longsleeve",
    label: "Long Sleeve Shirt",
    views: [
      {
        view: "front",
        label: "Front",
        image: "/mockups/longsleeve-front.png",
        printableArea: {
          x: 0.335,
          y: 0.225,
          width: 0.37,
          height: 0.37,
          unit: "percent",
        },
        centerOffsetX: 3.5,
        centerOffsetY: 3,
        defaultOffsetX: 0,
        defaultOffsetY: -6,
      },
      {
        view: "back",
        label: "Back",
        image: "/mockups/longsleeve-back.png",
        printableArea: {
          x: 0.325,
          y: 0.205,
          width: 0.39,
          height: 0.40,
          unit: "percent",
        },
        centerOffsetX: 3.5,
        centerOffsetY: 5,
        defaultOffsetX: 0,
        defaultOffsetY: -4,
      },
    ],
  },
  {
    id: "crewneck",
    label: "Crewneck Sweatshirt",
    views: [
      {
        view: "front",
        label: "Front",
        image: "/mockups/crewneck-front.png",
        printableArea: {
          x: 0.31,
          y: 0.215,
          width: 0.41,
          height: 0.37,
          unit: "percent",
        },
        centerOffsetX: 3,
        centerOffsetY: 3,
        defaultOffsetX: 0,
        defaultOffsetY: -6,
      },
      {
        view: "back",
        label: "Back",
        image: "/mockups/crewneck-back.png",
        printableArea: {
          x: 0.305,
          y: 0.19,
          width: 0.42,
          height: 0.40,
          unit: "percent",
        },
        centerOffsetX: 3.5,
        centerOffsetY: 5.5,
        defaultOffsetX: 0,
        defaultOffsetY: -4,
      },
    ],
  },
  {
    id: "youth-tee",
    label: "Youth T-Shirt",
    views: [
      {
        view: "front",
        label: "Front",
        image: "/mockups/youth-tee-front.png",
        printableArea: {
          x: 0.33,
          y: 0.43,
          width: 0.34,
          height: 0.20,
          unit: "percent",
        },
        centerOffsetX: 0,
        centerOffsetY: 6,
        defaultOffsetX: 0,
        defaultOffsetY: -3,
      },
      {
        view: "back",
        label: "Back",
        image: "/mockups/youth-tee-back.png",
        printableArea: {
          x: 0.32,
          y: 0.36,
          width: 0.36,
          height: 0.22,
          unit: "percent",
        },
        centerOffsetX: 0,
        centerOffsetY: 5.5,
        defaultOffsetX: 0,
        defaultOffsetY: -2,
      },
    ],
  },
];

export function findMockupGarment(garmentId: string) {
  return mockupGarments.find((item) => item.id === garmentId) || null;
}

export function findMockupView(garmentId: string, view: MockupView) {
  const garment = findMockupGarment(garmentId);
  if (!garment) return null;
  return garment.views.find((item) => item.view === view) || garment.views[0] || null;
}